var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "input",
      _vm._g(
        {
          class:
            _vm.isInputHidden === false
              ? "form-control"
              : "form-control v-hidden",
          attrs: {
            type: "password",
            id: "otp",
            npkencrypt: "on",
            "data-keypad-type": "number",
            "data-keypad-theme": "mobile",
            "data-keypad-extend-ui": "advancedotp",
            "data-keypad-next": "__hide__",
            maxlength: "7"
          }
        },
        _vm.NOS_INSTANCE.listeners()
      )
    ),
    _c("input", {
      attrs: { type: "hidden" },
      domProps: { value: _vm.getIncaOpen }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }